// Per-role primary destinations for the mobile bottom navigation. Each role gets 4 core tabs
// (in the thumb zone) plus an auto-appended "More" tab that opens the full grouped menu.
// GUARD is intentionally absent — that role runs kiosk-style and keeps its own layout.
//
// `name` is a vue-router route name; `icon` is a Vuestic VaIcon name; `labelKey` is an i18n key
// (reused from the sidebar's menu.* keys). `match` lists extra route names that should keep the
// tab highlighted (e.g. a detail page under a list tab).

export interface BottomTab {
  name: string
  labelKey: string
  icon: string
  match?: string[]
}

// Association & super admins share a set; platform/oversight screens live under "More".
const ADMIN_TABS: BottomTab[] = [
  { name: 'dashboard', labelKey: 'menu.dashboard', icon: 'vuestic-iconset-dashboard' },
  { name: 'households', labelKey: 'menu.households', icon: 'home', match: ['household-detail'] },
  { name: 'billing', labelKey: 'menu.billing', icon: 'mso-receipt_long' },
  { name: 'guard-visitors', labelKey: 'menu.visitorCenter', icon: 'mso-badge', match: ['visitor-passes'] },
]

const HOMEOWNER_TABS: BottomTab[] = [
  { name: 'my-dashboard', labelKey: 'menu.myDashboard', icon: 'mso-home' },
  { name: 'my-bills', labelKey: 'menu.myBills', icon: 'mso-receipt_long', match: ['my-payments'] },
  { name: 'visitor-center', labelKey: 'menu.visitorCenter', icon: 'mso-badge', match: ['my-visitor-passes'] },
  { name: 'my-vehicles', labelKey: 'menu.myVehicles', icon: 'mso-directions_car' },
]

const BOARD_AUDITOR_TABS: BottomTab[] = [
  { name: 'announcements', labelKey: 'menu.announcements', icon: 'mso-campaign' },
  { name: 'billing', labelKey: 'menu.billing', icon: 'mso-receipt_long' },
  { name: 'reports', labelKey: 'menu.reports', icon: 'mso-analytics' },
  { name: 'audit-annual', labelKey: 'menu.auditAnnual', icon: 'mso-assignment' },
]

export const BOTTOM_NAV_TABS: Record<string, BottomTab[]> = {
  SUPER_ADMIN: ADMIN_TABS,
  ASSOCIATION_ADMIN: ADMIN_TABS,
  BOARD_AUDITOR: BOARD_AUDITOR_TABS,
  HOMEOWNER: HOMEOWNER_TABS,
}
